import get from "lodash/get"
import isFunction from "lodash/isFunction"

export const getFlattenColumns = function(columns, flat = []) {
  columns.forEach(col => {
    if (col.children && col.children.length) {
      flat = flat.concat(getFlattenColumns(col.children))
    } else {
      flat.push(col)
    }
  })

  return flat
}

export const getScrollBarWidth = function() {
  const wrapper = document.createElement("div")
  const styles = {
    width: "50px",
    height: "50px",
    overflow: "scroll",
    position: "absolute",
    opacity: 0,
  }
  let width = 0

  for (let key in styles) {
    wrapper.style[key] = styles[key]
  }

  document.body.appendChild(wrapper)
  width = wrapper.offsetWidth - wrapper.clientWidth
  wrapper.remove()

  return width
}

export const getValue = ({ row, column }) => {
  const value = get(row, column.key)
  return isFunction(column.transform) ? column.transform({ row, column, value }) : value
}
